module.exports = __webpack_public_path__ + "5bf19dbe2348bc22c605195d08285256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/6.jpg
// module id = ./src/components/Carousel/images/6.jpg
// module chunks = 0